import React from 'react'
import { WidgetProps } from '@rjsf/utils'

import 'ace-builds/src-noconflict/mode-css'

import { EditorWidget } from './EditorWidget'

export const EditorCssWidget: React.FC<WidgetProps> = props => {
  return <EditorWidget mode={'css'} {...props} />
}
